import auth0 from 'auth0-js';
import history from './history';
var apigClientFactory = require('aws-api-gateway-client').default;

export default class Auth {

  constructor() {
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.handleAuthentication = this.handleAuthentication.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
  }

  // auth0 = new auth0.WebAuth({
  //   domain: 'hyperqode.au.auth0.com',
  //   clientID: 'hPDmbhrSPB92ml7J5CWSWt43Q0D20Q4V',
  //   redirectUri: window.location.protocol + "//" + window.location.host + '/callback',
  //   //audience: 'https://hyperqode.au.auth0.com/userinfo',
  //   audience: 'https://2nwjbzthii.execute-api.ap-southeast-2.amazonaws.com/dev',
  //   responseType: 'token id_token',
  //   scope: 'openid'
  // });

  // auth0 = new auth0.WebAuth({
  //   domain: 'acme-review-64-integra-qac0kc.centricidentity.com/api/v1/connect/',
  //   clientID: 'jOwDIVkAOJHQMY8IfaQrrI9e',
  //   redirectUri: window.location.protocol + "//" + window.location.host + '/callback',
  //   //audience: 'https://hyperqode.au.auth0.com/userinfo',
  //   audience: 'jOwDIVkAOJHQMY8IfaQrrI9e',
  //   responseType: 'token id_token',
  //   scope: 'openid',
  //   overrides: {
  //     __tenant: 'tenant1',
  //     __token_issuer: 'https://acme-review-64-integra-qac0kc.centricidentity.com/api/v1/connect/'
  //   }
  // });

  // auth0 = new auth0.WebAuth({
  //   domain: 'acme-review-79-refresh-jdh7mi.centricidentity.com/api/v1/connect/',
  //   clientID: 'JDJhJDEwJDR0dTZ0djZMcTBHcWJndUU5OTI2Sk8=',
  //   redirectUri: window.location.protocol + "//" + window.location.host + '/callback',
  //   audience: 'JDJhJDEwJDR0dTZ0djZMcTBHcWJndUU5OTI2Sk8=',
  //   responseType: 'token id_token',
  //   scope: 'openid',
  //   overrides: {
  //     __tenant: 'tenant1',
  //     __token_issuer: 'https://acme-review-79-refresh-jdh7mi.centricidentity.com/api/v1/connect/'
  //   }
  // });

  // auth0 = new auth0.WebAuth({
  //   domain: 'assertiv.assertiv.com/api/v1/connect/',
  //   clientID: 'EvElEXLdF0jt5AllluyadnJZ',
  //   redirectUri: window.location.protocol + "//" + window.location.host + '/callback',
  //   //audience: 'https://hyperqode.au.auth0.com/userinfo',
  //   audience: 'jOwDIVkAOJHQMY8IfaQrrI9e',
  //   responseType: 'token id_token',
  //   scope: 'openid',
  //   overrides: {
  //     __tenant: 'tenant1',
  //     __token_issuer: 'https://assertiv.assertiv.com/api/v1/connect/'
  //   }
  // });

  auth0 = new auth0.WebAuth({
    domain: 'dev-ktwv3i3mxofd0jgv.us.auth0.com',
    clientID: 'tcagBfX4Go83eonHFkeXpfimKCZWVyVg',
    redirectUri: window.location.protocol + "//" + window.location.host + '/callback',
    audience: 'https://dev-ktwv3i3mxofd0jgv.us.auth0.com/userinfo',
    responseType: 'code',
    scope: 'openid profile',
    overrides: {
      __tenant: 'tenant1',
      __token_issuer: 'https://dev-ktwv3i3mxofd0jgv.us.auth0.com/'
    }
  });

  // Working Assertiv
  // auth0 = new auth0.WebAuth({
  //   domain: 'hq.assertiv.com/api/v1/connect/',
  //   clientID: 'JDJhJDEwJFZXNVppN3R0WHhLTVRDM1E0MEtmRi4=',
  //   redirectUri: window.location.protocol + "//" + window.location.host + '/callback',
  //   //audience: 'https://hyperqode.au.auth0.com/userinfo',
  //   audience: 'jOwDIVkAOJHQMY8IfaQrrI9e',
  //   responseType: 'token id_token',
  //   scope: 'openid profile',
  //   overrides: {
  //     __tenant: 'tenant1',
  //     __token_issuer: 'https://hq.assertiv.com/api/v1/connect/'
  //   }
  // });

  // auth0 = new auth0.WebAuth({
  //   domain: 'login.hypersocio.com/api/v1/connect/',
  //   clientID: 'JDJhJDEwJFZXNVppN3R0WHhLTVRDM1E0MEtmRi4=',
  //   redirectUri: window.location.protocol + "//" + window.location.host + '/callback',
  //   //audience: 'https://hyperqode.au.auth0.com/userinfo',
  //   audience: 'jOwDIVkAOJHQMY8IfaQrrI9e',
  //   responseType: 'token id_token',
  //   scope: 'openid',
  //   overrides: {
  //     __tenant: 'tenant1',
  //     __token_issuer: 'https://hq.assertiv.com/api/v1/connect/'
  //   }
  // });

  login() {
    this.auth0.authorize();
  }

  handleAuthentication() {
    this.auth0.parseHash((err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        this.setSession(authResult);
      } else if (err) {
        console.log(err);
      }
    });
  }

  setSession(authResult) {
    // Set the time that the Access Token will expire at
    let expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
    localStorage.setItem('access_token', authResult.accessToken);
    localStorage.setItem('id_token', authResult.idToken);
    localStorage.setItem('expires_at', expiresAt);
    
    var config = { invokeUrl: "https://dev-ktwv3i3mxofd0jgv.us.auth0.com/userinfo" }
    var apigClient = apigClientFactory.newClient(config);
    var params = {};
    var pathTemplate = ''
    var method = 'GET';
    var additionalParams = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem('access_token')
      }
    };
    var body = {
    };
    
    apigClient.invokeApi(params, pathTemplate, method, additionalParams, body)
    .then(function(result){
        //This is where you would put a success callback
        //alert("Success - " + JSON.stringify(result));
        // navigate to the home route
        window.location = "/dashboard";
        return;
    }).catch( function(result){
      console.log("Fail - " + result);
      return;
      //This is where you would put an error callback
    });
    // const request = require('request');
    // request('https://hq.assertiv.com/api/v1/connect/userinfo', function (error, response, body) {
    //   console.error('error:', JSON.stringify(error)); // Print the error if one occurred
    //   console.log('statusCode:', response && response.statusCode); // Print the response status code if a response was received
    //   console.log('body:', body); // Print the HTML for the Google homepage.
    // });
  }

  logout() {
    // Clear Access Token and ID Token from local storage
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
  }

  isAuthenticated() {
    // Check whether the current time is past the 
    // Access Token's expiry time
    let expiresAt = JSON.parse(localStorage.getItem('expires_at'));
    if( new Date().getTime() < expiresAt ){
      return true;
    }else{
      return false
    }
  }
}